2.<template>
  <div v-on:click="openMovie()"
    class="dorm-card"
    :class="[{
        premium : movie.is_advert,
        male : movie.dorm_type_id === 1,
        female : movie.dorm_type_id === 2
      }]">
    <div class="dorm-card__top">
      <!--"dorm-card-badge" elementi sadece dorm 1. sıra sabit reklamı var ise görünür.-->
      <div class="dorm-card-badge" v-if="movie.is_advert">
        
        <div class="badge_in">
          <div class="img_wrp">
            <img src="@/assets/img/star-icon-white.svg" alt="" class="img-fluid">
          </div>
          <span>Popular</span>
        </div>

        <!-- <div class="button red icon-left" :class="[{
        premium : movie.is_advert,
        male : movie.dorm_type_id === 1,
        female : movie.dorm_type_id === 2
      }]">
          <span class="button__wrp">
            <span class="button__icon">
              
              <img src="@/assets/img/star-icon-white.svg" alt="" class="img-fluid" width="20">
              
            </span>
            <span class="button__txt">
                Popüler Tercih
            </span>
          </span>
        </div> -->
      </div>
      <img :src="'http://image.tmdb.org/t/p/w185/' + movie.poster_path" alt="" class="dorm-card__img">
      <div class="dorm-card__overlay">

      <v-button
        class="dorm-card__button"
        title="Inspect"
      />
      </div>
    </div>
    <div class="dorm-card__cnt">
      <div class="dorm-card__content">
        <div class="dorm-card__title">
          <small v-if="!movie.branch_count || !movie.center_slug">Release Date {{ movie.release_date }}{{ movie.air_date }}</small>
          <small v-if="movie.branch_count > 0 && movie.center_slug">{{ distinctCities }}</small>
          <span class="dorm-card__title-main" :title="movie.name" v-if="!movie.branch_count || !movie.center_slug">
            <strong>{{ movie.title}} {{ movie.name }}</strong>
          </span>
          <span class="dorm-card__title-main" title="">
          {{ movie.overview.slice(0, 75) }}...
          </span>          
        </div>
        <!--<div class="dorm-card-price">-->
        <!--<div class="dorm-card-price__title">-->
        <!--{{ movie.price }} TL-->
        <!--</div>-->
        <!--<div class="dorm-card-price__txt">-->
        <!--‘den başlayan<br>oda fiyatları-->
        <!--</div>-->
        <!--</div>-->
      </div>
      <div class="dorm-card__bottom">
        <div class="show-tel" v-show="movie.big" @click.prevent="showTel" v-if="show">
          <span class="show-tel__icon">
            <svg-icon type="icon-phone" />
          </span>
          Telefona Bak
        </div>
        <div class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-branches"/>
          </div>
          <div class="btn-txt">
            {{ movie.popularity }} Popularity
          </div>
        </div>        
        <div class="dorm-card__inf" v-if="!movie.branch_count || !movie.center_slug">
          <div class="icon-font">
            <svg-icon type="icon-user"/>
          </div>
          <div class="btn-txt">
            {{ movie.vote_average }} Votes
          </div>
        </div>

        <div v-if="movie.adult" class="dorm-card__inf" >
          <div class="icon-font">
            <svg-icon type="icon-food"/>
          </div>
          <div class="btn-txt">
            {{ movie.adult }} Adult
          </div>
        </div>
<!--         <div v-else-if="!movie.video && !movie.is_wifi && !movie.branch_count " class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-food"/>
          </div>
          <div class="btn-txt" disabled>
            Yok
          </div>
        </div>   -->      
        <div v-else-if="!movie.video && movie.is_wifi && !movie.branch_count" class="dorm-card__inf">
          <div class="icon-font">
            <svg-icon type="icon-wifi"/>
          </div>
          <div class="btn-txt">
            Wifi Var
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utiliy from '../common'
import axios from 'axios'
export default {
  name: 'SerieCard2',
  data () {
    return {
      show: true,
      branchnumber: '',
      branchNames: '',
      distinctCities: ''
    }
  },
  props: {
    movie: Object
  },
  methods: {

    convertString(movie) {
      return  Array.toString(movie.genre_ids)
      /*
      var mystr
        movie.genre_ids.forEach((data) => {
             mystrs  = + data.toString()
            })
            return mystr
            */
    },
        string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },
     convertDate(stringdate)
{
    // Internet Explorer does not like dashes in dates when converting, 
    // so lets use a regular expression to get the year, month, and day 
    var DateRegex = /([^-]*)-([^-]*)-([^-]*)/;
    var DateRegexResult = stringdate.match(DateRegex);
    var DateResult;
    var StringDateResult = "";

    // try creating a new date in a format that both Firefox and Internet Explorer understand
    try
    {
        DateResult = new Date(DateRegexResult[2]+"/"+DateRegexResult[3]+"/"+DateRegexResult[1]);
    } 
    // if there is an error, catch it and try to set the date result using a simple conversion
    catch(err) 
    { 
        DateResult = new Date(stringdate);
    }

    // format the date properly for viewing
    StringDateResult = (DateResult.getMonth()+1)+"/"+(DateResult.getDate()+1)+"/"+(DateResult.getFullYear());
    //console.log(StringDateResult);

    return StringDateResult;
},
  getDistricts() {
    //const id = window.localStorage.getItem('branchedDormId')
    var self = this
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
       const url = `/site/dorm/branches/${this.movie.id}`
       // let distinctArray = []
/*               let district1 = {
               name: 'Tüm İlçeler',
               slug: 'tum-ilceler'
             }
       this.districts.push(district1) */

       axios.get(url)
         .then(response => {
           // this.isLoading = false
           // self.detail = response.data

           if(response.data.branches.length > 1) {
             let distinctArray = [...new Set(response.data.branches.map(x => x.city.name))]
             distinctArray.forEach((data) => {
             self.distinctCities  = self.distinctCities + data + ', '
/*              let district = {
               name: data,
               slug: self.string_to_slug(data)
             } */
             // self.districts.push(district)
            })
            let ewStr = self.distinctCities.substring(0, self.distinctCities.length - 1);
            let ewStr2 = ewStr.substring(0, ewStr.length - 1)
            if(ewStr2.includes(', ')) {
              self.distinctCities = ewStr2 //ewStr.substring(0, ewStr.length - 1);
            }else {
             self.distinctCities = response.data.city.name + ' Şubeleri'
           } 

            
             // window.localStorage.setItem('branchnumber', response.data.branches.length)
           }     
    })
  },    
    mobileCheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
},
    showTel () {
      this.show = false
    },
    openMovie () {
      
      window.localStorage.setItem('dormid', this.movie.id)
      let url = 'http://www.holywoodskyline.com/' + this.movie.slug + '-y-' + this.movie.id
      window.localStorage.setItem('url', url)
      window.localStorage.setItem('description', this.movie.release_date)
      window.localStorage.setItem('name', this.movie.name)
      /*

     // window.localStorage.setItem('city', this.movie.city.slug)
      

      if(this.movie.branch_count > 0 && this.movie.center_slug) {
    var self = this
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`    
            window.localStorage.setItem('branchedDormTitle', this.movie.center_name)
             window.localStorage.setItem('branchDescription', this.movie.description)
             window.localStorage.setItem('branchKeywords', this.movie.keywords)
             window.localStorage.setItem('branchedDormId', this.movie.id)
             
             if(this.movie.logo) {
             window.localStorage.setItem('dormLogo', this.movie.logo)
             }

             window.localStorage.setItem('dormWeb', this.movie.web)
             window.localStorage.setItem('slug', this.movie.center_slug)
             if(this.movie.center_description) {
              window.localStorage.setItem('center_description', this.movie.description)
              window.localStorage.setItem('center_keywords', this.movie.keywords)
             }
             if(this.movie.city) {
              window.localStorage.setItem('city', this.movie.city.name)
             }
             // let dorm = this.string_to_slug(this.movie.slug)
             let route = { name: 'Branch', params: { movie: string_to_slug(this.movie.original_title), id:this.movie.id } }
             this.$router.push(route)
      }
    else {
        window.localStorage.setItem('slug', this.movie.name + '-y-' + this.movie.id)

        
      if(this.mobileCheck()) {
        window.open(window.location.origin + '/' + this.movie.name + '-y-' + this.movie.id, '_self')
      } else {
        window.open(window.location.origin + '/' + this.movie.name + '-y-' + this.movie.id, '_blank')
      }
}


*/
      let slug
      if (this.movie.title) {
        slug = Utiliy.string_to_slug(this.movie.title)
      } else {
        slug = Utiliy.string_to_slug(this.movie.name)
      }
      const route = { name: 'SerieDetail', params: { slug: slug, id:this.movie.id } }
      this.$router.push(route)


    }
  },
   created() {
     if(this.movie.branch_count > 0 && this.movie.center_slug) {
      // this.getDistricts()
     }
    let movie = this.movie
    if(!this.movie.city) {
      this.movie.city = {
        name: ''
      } }
      
    if(!this.movie.district) {
      this.movie.district = {
        name: ''
      }      
    }
    // if(this.movie.name.includes('Şişli Şube') || this.movie.name.includes('Sinanpaşa')) {
    // }
  } 
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/components/dorm-card";
  .mywashed {
    background-blend-mode: lighten
  }
</style>
